import { ConnectProto } from "@racoon/api";
import { Namespace, TranslationKey, useT } from "@racoon/i18n";
import { getEnumName } from "@racoon/lib";
import { StatusPill } from "@racoon/ui";
import { jobStatusTone } from "~/features/map-view/model/constants/job-status-colors";
import { useIsOwnOrganizationForWrite } from "~/shared/hooks/use-is-own-organization";
import { useFreshJob } from "~/shared/hooks/use-fresh-job";
import { JobHeadingLinks } from "./job-heading-links";

/** The job's number over the card type, its status, then links to the site, customer and trip. */
export const JobCardHeading = ({ job }: { job: ConnectProto.Job }) => {
  const t = useT();
  // As the card's cancel action sees it: the list's copy may be out of date
  const status = (useFreshJob(job) ?? job).status;
  const tone = jobStatusTone(status);
  const isOwnForWrite = useIsOwnOrganizationForWrite("job");

  return (
    <div className="flex min-w-0 items-center gap-4" data-testid="job-card-heading">
      <div className="flex flex-shrink-0 flex-col gap-1">
        <span className="text-base font-semibold leading-4 tracking-[-0.01em] text-text-body">
          Z{String(job.id)}
        </span>
        <span className="text-xs font-bold uppercase leading-4 text-text-subtle">
          {t(Namespace.Orders, "card.title")}
        </span>
      </div>
      <div className="flex min-w-0 flex-1 items-center gap-2.5">
        <StatusPill
          tone={tone && `${tone.bg} ${tone.color}`}
          className="flex-shrink-0 tracking-[-0.01em]"
          data-testid="job-card-status"
        >
          {t(
            Namespace.Enum,
            getEnumName(ConnectProto.JobStatusSchema, status) as TranslationKey<Namespace.Enum>,
          )}
        </StatusPill>
        <JobHeadingLinks
          location={job.pickupLocation}
          customer={job.serviceReceiver}
          orderNumber={job.orderNumber}
          routeId={job.routeId}
          readOnly={isOwnForWrite(job.serviceProviderId, job.serviceReceiverId) !== true}
        />
      </div>
    </div>
  );
};
